/* eslint-disable react/react-in-jsx-scope */
import {
    IAccusationService,
    IAccusationServiceDelegates,
} from './accusation-service.interface';
import ReactDOM from 'react-dom';
import Snackbar from '@tencent/dui/lib/components/Snackbar';
import style from './accusation-service.less';
import i18n from '@i18next/i18n';
import config, { EnterPriseType } from '@src/js/service/enterprise/temp-config';
import tdocsBridge from '@src/slide/infrastructure/module/independent/tdocsBridge/tdocsBridge';
import { LINK } from '@src/slide/infrastructure/module/dependent/config/tob/constant';
import { SlideDataServices } from '@src/slide/domain/slide-app/core/slide-data-services.core';
import { OnlineEditServices } from '@src/slide/domain/slide-app/scenes/online/core/online-edit-services.core';
import { showDclReport } from '@src/js/common/ark-extensions/dc-components/dcl-report';

export class AccusationService implements IAccusationService {
    private urlUserReport = '';
    private showJuBao = false;
    private services: IAccusationServiceDelegates;

    public setServiceDelegates(services: IAccusationServiceDelegates) {
        this.services = {
            ...this.services,
            ...services,
        };
    }

    // 显示举报页面
    public async showJuBaoPage() {
        const { domainId = '', padId = '' } = await SlideDataServices.DocInfoManager.promise();
        const apiService = await OnlineEditServices.OnlineApiService.promise();
        apiService.getUserReportToken(domainId, padId).then(this.onGetUserReportToken);
    }

    public onGetUserReportToken = (response) => {
        try {
            const res = response.data;
            if (res.retcode === 0 && res.token.length > 0) {
                let { token } = res;
                token = encodeURIComponent(token);
                // TODO userDomain 是 从clientVar 中获取的，目前已经咩有这个字段了，不知道怎么换
                const param = `token=${token}&scene=6001&openid=${SlideDataServices?.ClientVarsService?.()?.getClientVars()?.userDomain}`;
                const url = `${LINK.REPORT}?${param}`;
                this.urlUserReport = url;
                this.showJuBao = true;
                window.addEventListener('message', this._onReciveJuBaoPageMessage);
                this._renderJuBaoPage();
            } else {
                Snackbar.show({
                    message: i18n.t('请求失败，请稍后重试。'),
                    duration: 5000,
                });
            }
        } catch (error) {
            Snackbar.show({
                message: i18n.t('请求失败，请稍后重试。'),
                duration: 5000,
            });
        }
    };

    // 关闭举报页面
    public hideJuBaoPage() {
        this.showJuBao = false;
        window.removeEventListener('message', this._onReciveJuBaoPageMessage);
        this._renderJuBaoPage();
    }

    // 以下为反馈相关代码
    // 显示反馈
    public showSupportPage = (jumpToSubmit?: boolean) => {
        if (config.supportEnterprise(EnterPriseType.ALL)
            && tdocsBridge.tdocs) {
            return tdocsBridge.tdocs.openSupportPage();
        }
        // 收集登录态所需数据
        const info = this.getUserInfo();
        const { nick } = info;
        const { avatar } = info;
        let uid = info.uid || '';
        // 微信登录还有 4 月份的新 qq 用户的情况下 uid 和 uin 是一样的
        // qq 登录的老用户以 clientVars 的 userId，cgi/user_info 的 uid 为准
        if (uid) {
            if (uid.charAt(0) === 'p') {
                uid = uid.replace(/p./, '');
            }
        } else {
            // TODO uin 是 从clientVar 中获取的，目前已经咩有这个字段了，不知道怎么换
            uid = SlideDataServices.ClientVarsService()?.getClientVars().uin;
        }

        let gray = ' ';


        if (typeof (SlideDataServices.DocInfoManager()?.pVer) !== 'undefined') {
            gray = `${gray} pver/${SlideDataServices.DocInfoManager()?.baseRevision}`;
        }

        if (typeof (SlideDataServices.DocInfoManager()?.gray) !== 'undefined') {
            gray = `${gray} gray/${SlideDataServices.DocInfoManager()?.gray}`;
        }

        const clientInfo = window.navigator.userAgent + gray;

        this.gotoTucaoWithLoginState({
            openid: uid,
            nickname: nick,
            avatar,
            url: window.location.href,
            clientInfo,
        }, jumpToSubmit);
    };

    private _onReciveJuBaoPageMessage = (event) => {
        if (event?.data) {
            try {
                let jsonData = event.data;
                if (typeof event.data === 'string') {
                    jsonData = JSON.parse(event.data);
                }
                if (jsonData && jsonData.from === 'jubao' && jsonData.cmd === 'jubao_close') {
                    this.hideJuBaoPage();
                }
            } catch (error) {
                window.log?.error(`onReciveJuBaoPageMessage error:${error}`);
            }
        }
    };

    private _renderJuBaoPage = () => {
        const url = this.urlUserReport;
        let jubaoContianer = document.getElementById('jubao-contianer');
        if (!jubaoContianer) {
            jubaoContianer = document.createElement('div');
            jubaoContianer.id = 'jubao-contianer';
            document.body.appendChild(jubaoContianer);
        }
        ReactDOM.render(
            (
                this.showJuBao
                    ? (
                        <div>
                            <div className={style['userReport-container']}>
                                <iframe className={style['userReport-frame']} src={url} />
                            </div>
                            <div className={style['userReport-mask']} />
                        </div>
                    ) : (<></>)
            ), jubaoContianer,
        );
    };

    private gotoTucaoWithLoginState = (data, jumpToSubmit) => {
        showDclReport(data, jumpToSubmit);
    };

    private getUserInfo() {
        return this.services.extensionService.getDocInfo()?.userInfo || {};
    }
}
